import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CheckboxesContainer, CheckboxAndLabel, CheckboxClickableArea, CheckboxLabelAndLink, CheckboxLabel, CheckboxOrange } from './styled-components/Checkboxes'

const MarketingEmailOptInUser = (props) => {
    return (
        <CheckboxesContainer data-marketing-email-checkbox>

            <CheckboxAndLabel>
                <CheckboxClickableArea onClick={props.handleMarketingEmailOptInUser}>
                    <CheckboxOrange checked={props.marketingEmailOptInUser}>
                        {props.marketingEmailOptInUser ? <FontAwesomeIcon icon="check" color="white" /> : null}
                    </CheckboxOrange>
                </CheckboxClickableArea>
                <CheckboxLabelAndLink>
                    <CheckboxLabel removeHeight>Send me updates from Anova with the latest recipes, sales, news, and product releases.</CheckboxLabel>
                </CheckboxLabelAndLink>
            </CheckboxAndLabel>

        </CheckboxesContainer>
    )
}

export default MarketingEmailOptInUser
